import { render, staticRenderFns } from "./DegreeInfo.vue?vue&type=template&id=447a5b6c&scoped=true"
import script from "./DegreeInfo.vue?vue&type=script&lang=js"
export * from "./DegreeInfo.vue?vue&type=script&lang=js"
import style0 from "./DegreeInfo.vue?vue&type=style&index=0&id=447a5b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a5b6c",
  null
  
)

export default component.exports